import Vue from 'vue'
import VueTippy from 'vue-tippy'

Vue.use(VueTippy, {
  placement: 'bottom',
  arrow: true,
  delay: [80, 0]
})
